var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.contents),function(content){return _c('div',{key:content.id,staticClass:"text-body-4 grey-darken-3--text"},[_vm._v("\n    "+_vm._s(content.translated.content)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }